import { Alert, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TableComp from "../component/Table";
import { useState, useEffect, useCallback } from "react";
import { t } from "i18next";
import { BiSolidDollarCircle } from "react-icons/bi";
import { BsGraphUpArrow } from "react-icons/bs";
import { FiDivideCircle } from "react-icons/fi";
import ApiUtil from "../util/ApiUtil";
import ApiPath from "../util/ApiPath";
import Pagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import ReactLoading from "react-loading";
import SessionUtil from "../util/SessionUtil";
import ListGroup from "../component/ListGroup";
import { HiPhone } from "react-icons/hi2";
import { TiLocation } from "react-icons/ti";
import { ActionRow } from "../component/ActionRow";

const CustomRow = ({ rowData, columnNames, handleClickRow }) => {
  return (
    <tr>
      {columnNames.map((columnName, index) => (
        <td key={index}>
          {columnName === "orderNo" ? (
            <span title={"#" + rowData.OrderId}>#{rowData.OrderId}</span>
          ) : columnName === "Username" ? (
            <p className="mb-0" title={rowData.UserName}>
              {rowData.UserName}
            </p>
          ) : columnName === "Phone Number" ? (
            <div className="flex-gap-2">
              <HiPhone size={16} color={"#3A974C"} />{" "}
              <p
                className="mb-0"
                title={
                  "+" + rowData.UserAreaCode + "" + rowData.UserPhoneNumber
                }
              >
                {"+" + rowData.UserAreaCode + "" + rowData.UserPhoneNumber}
              </p>
            </div>
          ) : columnName === "UserAddress" ? (
            <div className="flex-gap-2">
              <TiLocation size={16} color="#4285F4" />
              <p
                className="mb-0"
                title={rowData?.UserAddress ? rowData?.UserAddress : "---"}
              >
                {rowData?.UserAddress ? rowData?.UserAddress : "---"}
              </p>{" "}
            </div>
          ) : columnName === "StoreAddress" ? (
            <div className="flex-gap-2">
              <TiLocation size={16} color="#4285F4" />
              <p
                className="mb-0"
                title={rowData?.StoreLocation ? rowData?.StoreLocation : "---"}
              >
                {rowData?.StoreLocation ? rowData?.StoreLocation : "---"}
              </p>{" "}
            </div>
          ) : columnName === "StoreCoordinates" ? (
            <div className="flex-gap-2">
              <TiLocation size={16} color="#4285F4" />
              <p
                className="mb-0"
                title={
                  rowData?.StoreLongitudeAndLatitude
                    ? rowData?.StoreLongitudeAndLatitude
                    : "---"
                }
              >
                {rowData?.StoreLongitudeAndLatitude
                  ? rowData?.StoreLongitudeAndLatitude
                  : "---"}
              </p>{" "}
            </div>
          ) : columnName === "Total" ? (
            <div className="flex-gap-2">
              <BiSolidDollarCircle size={16} color={"#3A974C"} />{" "}
              <p className="mb-0" title={rowData.TotalPrice}>
                {rowData.TotalPrice}
              </p>
            </div>
          ) : columnName === "TotalWithProfit" ? (
            <div className="flex-gap-2">
              <BsGraphUpArrow size={16} color="#F2953C" />{" "}
              <p className="mb-0" title={rowData.TotalPriceWithProfit}>
                {rowData.TotalPriceWithProfit}
              </p>{" "}
            </div>
          ) : columnName === "TaxFee" ? (
            <div className="flex-gap-2">
              <FiDivideCircle size={16} color="#4285F4" className="rotate-45" />{" "}
              <p className="mb-0" title={rowData.TaxFee}>
                {rowData.TaxFee}
              </p>{" "}
            </div>
          ) : columnName === "Status" ? (
            <div className={rowData.IsReorder ? "flex-gap-2" : ""}>
              <div className="status status-warning">
                <p className="mb-0">{t("Pending")}</p>
              </div>
              {rowData.IsReorder && (
                <div className="status status-success">
                  <p className="mb-0">{t("Reorder")}</p>
                </div>
              )}
            </div>
          ) : (
            <p className="mb-0" title={rowData[columnName]}>
              {rowData[columnName]}
            </p>
          )}
        </td>
      ))}
      <td>
        <ActionRow
          handleClickRow={handleClickRow}
          id={rowData.OrderId}
          page="orderPending"
        />
      </td>
    </tr>
  );
};

const OrdersPending = () => {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);
  const [recordCount, setRecordCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const isLoggedIn = SessionUtil.isLoggedIn();
  const columnNames = [
    "orderNo",
    "Username",
    "Phone Number",
    "UserAddress",
    "StoreNameEn",
    "StoreNameAr",
    "StoreAddress",
    "StoreCoordinates",
    "Total",
    "TotalWithProfit",
    "TaxFee",
    "Status",
  ];
  const [sortedData, setSortedData] = useState([]);
  const [alertMsg, setAlertMsg] = useState(null);
  // getApi
  const getApi = useCallback(async () => {
    setLoading(true);
    let params;
    params = {
      PageNumber: currentPage,
      PageSize: 10,
      OrderBy: "Id Desc",
    };

    const res = await ApiUtil.postApi(
      ApiPath.GET_ALL_PENDING_ORDER,
      params,
      "POST"
    );
    if (res.IsSuccessfull) {
      const totalPage = Math.ceil(res.Result.RecordCount / 10);
      setSortedData(res.Result.Orders);
      setRecordCount(totalPage);
      setLoading(false);
    }
  }, [currentPage]);

  // useEffect
  useEffect(() => {
    if (isLoggedIn) {
      getApi();
    }
  }, [isLoggedIn, getApi]);
  // handlePageNumber
  const handlePageNumber = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const reorderPendingOrders = async (OrderId) => {
    setLoading(true);
    let params;
    params = {
      Id: OrderId,
    };

    const res = await ApiUtil.postApi(
      ApiPath.REORDER_PENDING_ORDERS,
      params,
      "PUT"
    );
    if (res.IsSuccessfull) {
      getApi();
      setAlertMsg(true);
      setTimeout(() => {
        setAlertMsg(null);
      }, 5000);
    } else {
      setAlertMsg(false);
    }
  };

  return (
    <>
      <Row className="g-0">
        {!loading ? (
          <>
            <Col lg={12} className="position-relative">
              <ListGroup />
              <div className=" mt-4 d-flex justify-content-between gap-2">
                <div className="flex-gap-2">
                  <p className="title mb-0">{t("Orders Pending")}</p>
                </div>
              </div>
              {alertMsg !== null &&
                (alertMsg ? (
                  <Alert variant={"success"} className="mt-3">
                    {t("The order has been resent successfully")}.
                  </Alert>
                ) : (
                  <Alert variant={"danger"} className="mt-3">
                    {t("Resend order failed")}.
                  </Alert>
                ))}

              <TableComp
                data={sortedData}
                columnNames={columnNames}
                setSortedData={setSortedData}
              >
                {sortedData.map((rowData, index) => (
                  <CustomRow
                    key={index}
                    rowData={rowData}
                    columnNames={columnNames}
                    handleClickRow={reorderPendingOrders}
                  />
                ))}
              </TableComp>
              <Pagination
                current={currentPage}
                total={recordCount}
                onPageChange={(pageNumber) => handlePageNumber(pageNumber)}
                extraClassName="justify-content-end"
              />
            </Col>

            <Col md={1}>
              <div className="divider-vertical mx-auto"></div>
            </Col>
          </>
        ) : (
          <Col lg={12} className="loading-style">
            <ReactLoading
              type={"bars"}
              color={"#c8c8c8"}
              height={"50px"}
              width={"50px"}
            />
          </Col>
        )}
      </Row>
    </>
  );
};

export default OrdersPending;
